<template>
    <div>
        <!-- 关联配置项 -->
        <el-table :data="detail.toCmdb">
            <el-table-column label="编号" prop="serialNumber"></el-table-column>
            <el-table-column label="标题" prop="title">
                <template slot-scope="scope">
                    <el-button type="text" @click="toCorrectDetail(scope.row.serialNumber)">{{scope.row.title}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props:{
            detail:Object,
        },
        data() {
            return {

            }
        },
        created() {

        },
        methods: {
            //点击待办或请求中列表名称时跳转对应详情
            toCorrectDetail(val){
                this.$router.push({path:'/configurationDetail',query:{serialNumber:val}})
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
